export { SuperCollectionProductItem } from './SuperCollectionProductItem';
